'use strict';

const _=require('pulsar-utils/dist-es6/_');
const BaseService=require('../../../dist-es6/client/angularCommon/baseService');
const TimeInterval=require('pulsar-utils/dist-es6/timeInterval');
const IncidentViewModel=require('../../../dist-es6/client/viewModels/incidentViewModel');
const DutyViewModel=require('../../../dist-es6/client/viewModels/dutyViewModel');
const TripViewModel=require('../../../dist-es6/client/viewModels/tripViewModel');
const FlightViewModel=require('../../../dist-es6/client/viewModels/flightViewModel');
const BaseZonedIntervalViewModel=require('../../../dist-es6/client/viewModels/baseZonedIntervalViewModel');
const ErrorMessages=require('../../../dist-es6/client/errorMessages');
const SocketResponse=require('../../../dist-es6/client/dtos/socketResponse');
const ae=require('../../../dist-es6/shared/extensions/assessmentsExtensions');let

ScheduleService=class ScheduleService extends BaseService{
constructor(socketService,notificationService,timeFormattingService){
super();
this._socketService=socketService;
this._notificationService=notificationService;
this._timeFormattingService=timeFormattingService;
}

async getScheduleFor(personInfo,interval,timezone){
const personalScheduleResponse=await this._socketService.sendAndWaitForResponse(
'GetPersonalSchedule',{
queryInterval:interval,
personId:personInfo.id,
employeeId:personInfo.employeeId,
activationStatus:personInfo.activationStatus,
timezone});


if(personalScheduleResponse.status!=='Ok'){
this._notificationService.displayNotification(ErrorMessages.OopsTryAgain,'error');
throw new Error(`'${personalScheduleResponse.status}' loading schedule for ${personInfo.id}`);
}

const personalSchedule=personalScheduleResponse.body;

const now=personalSchedule.now;
const predictedWorkday=_timeIntervalOrNull(personalSchedule.predictedWorkday);
const assessments=ae(personalSchedule.assessments||[]).filterOutFutureShifts({now,currentShift:predictedWorkday});
personalSchedule.assessments.forEach(a=>a.tooltipText=`${a.status}: ${a.reason}, ${this._timeFormattingService.timeInLocale(a.time,timezone)}`);

return{
personId:personalSchedule.personId,
now,
queryInterval:new TimeInterval(personalSchedule.queryInterval),
estimatesAsOfTime:SocketResponse.safeDeserializeDate(personalSchedule.estimatesAsOfTime),
duties:personalSchedule.duties.map(d=>new DutyViewModel(d)),
trips:personalSchedule.trips.map(t=>new TripViewModel(t)),
flights:personalSchedule.flights.map(t=>new FlightViewModel(t)),
bounds:_timeIntervalOrNull(personalSchedule.bounds),
sleep:personalSchedule.sleep.map(s=>new BaseZonedIntervalViewModel(s)),
sleepPromotingIntervals:personalSchedule.sleepPromotingIntervals.map(s=>new BaseZonedIntervalViewModel(s)),
incidents:personalSchedule.incidents.map(incident=>IncidentViewModel.createFrom(incident,incident,timezone,_.noop)),
assessments,
fatigue:_deserializeFatigue(personalSchedule.fatigue),
forecastFatigue:_deserializeFatigue(personalSchedule.forecastFatigue),
predictedWorkday,
pastShifts:(personalSchedule.pastShifts||[]).map(i=>new TimeInterval(i)),
dailyEffectiveStatuses:personalSchedule.dailyEffectiveStatuses};

}};


function _deserializeFatigue(fatigue){
if(!fatigue){
return[];
};

return fatigue.map(fp=>({
time:SocketResponse.safeDeserializeDate(fp.time),
value:fp.value}));

}

function _timeIntervalOrNull(interval){
return interval?new TimeInterval(interval):null;
}

module.exports=ScheduleService;
//# sourceMappingURL=scheduleService.js.map
